import apiClient from "../api-client.js";

export const TICKET_HOURS_STATUS_QUERY_KEY = ["tickets", "hours-status"];

// { requires_hours, can_create, remaining_minutes, can_purchase }. External agencies need a positive
// balance to open incidents; support tickets never consume hours.
export const getTicketHoursStatus = async () => {
  const response = await apiClient.get("/communication/tickets/hours-status/");
  return response.data;
};

export const isNoHoursError = (error) =>
  error?.response?.status === 403 && error?.response?.data?.code === "no_hours";
